export let flaggedGroupLabel = "NSrBUe";
export let unflaggedGroupLabel = "ivTEMb";
export let completedGroupLabel = "kbW3g";
export default {flaggedGroupLabel,unflaggedGroupLabel,completedGroupLabel};